import script from "./AddIncome.vue?vue&type=script&setup=true&lang=js"
export * from "./AddIncome.vue?vue&type=script&setup=true&lang=js"

import "./AddIncome.vue?vue&type=style&index=0&id=58c15758&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58c15758"]])

export default __exports__